/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

type ApiCallFunction<TParams, TResult> = (params: TParams) => Promise<TResult>

type WrappedApiCallFunction<TParams, TResult> = (
  params: TParams,
) => Promise<TResult | null>

function withErrorHandling<TParams, TResult>(
  function_: ApiCallFunction<TParams, TResult>,
): WrappedApiCallFunction<TParams, TResult> {
  return async (params: TParams): Promise<TResult | null> => {
    try {
      return await function_(params)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Hydra API Error', error)
      return null
    }
  }
}

export function wrapWithErrorHandling<
  T extends Record<string, ApiCallFunction<any, any>>,
>(
  funcs: T,
): {
  [K in keyof T]: WrappedApiCallFunction<Parameters<T[K]>[0], ReturnType<T[K]>>
} {
  const result: any = {}
  for (const key in funcs) {
    result[key] = withErrorHandling(funcs[key])
  }
  return result
}
